import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from './locales/en/translation.json'
import frTranslation from './locales/fr/translation.json'
import { getLang, getCookie } from './shared/tools'

let lang = getCookie('wp-wpml_current_language')

const resources = {
    en: {
        translation: enTranslation,
    },
    fr: {
        translation: frTranslation,
    },
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        lng: lang,
    })

// Custom detector
let wpmlCurrentLanguage = getLang()
i18n.changeLanguage(wpmlCurrentLanguage)

export default i18n
